import {styled} from '@mui/material/styles'
import {Paper} from '@mui/material'
import Typography from '@mui/material/Typography'

const PREFIX = 'ChartContainer'

const classes = {
  icon: `${PREFIX}-icon`,
  loadDataBoxAction: `${PREFIX}-loadDataBoxAction`,
  titleContainer: `${PREFIX}-titleContainer`,
  captionContainer: `${PREFIX}-captionContainer`,
  title: `${PREFIX}-title`
}

const getMinHeight = (fullScreen, chartName) => {
  if (fullScreen) return '100%'
  return chartName === 'PopulationDistributionChart' ? '400px' : '350px'
}

const getBaseMinHeight = (chartName) => {
  return chartName === 'PopulationDistributionChart' ? '400px' : '350px'
}

const Root = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'fullScreen' && prop !== 'first' && prop !== 'tabHeight' && prop !== 'chartName'
})(({theme: {spacing, palette, breakpoints, typography}, fullScreen, first, chartName}) => ({
  padding: chartName === 'PopulationDensityChart' ? 0 : spacing(2),
  flexGrow: 1,
  backgroundColor: palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  height: '100%',
  minHeight: getBaseMinHeight(chartName),
  borderRadius: 8,
  boxSizing: 'border-box',
  [breakpoints.up('lg')]: {
    height: chartName === 'PopulationDensityChart' ? 'calc(100vh - 250px)' : '100%',
    minHeight: getMinHeight(fullScreen, chartName),
    borderRight: first ? `1px solid ${palette.grey[400]}` : 'none'
  },

  [breakpoints.between('md', 'lg')]: {
    height: 'calc(100vh - 250px)'
  },
  [breakpoints.between('sm', 'md')]: {
    height: 'calc(100vh - 200px)'
  },
  [breakpoints.down('sm')]: {height: '60vh'},

  [`& .${classes.icon}`]: {
    fontSize: 400,
    color: palette.hpBlack
  },

  [`& .${classes.loadDataBoxAction}`]: {
    fontWeight: typography.fontWeightBold,
    color: palette.grey['700']
  },

  [`& .${classes.titleContainer}`]: {
    marginBottom: spacing(1.5)
  },

  [`& .${classes.captionContainer}`]: {
    marginTop: spacing(2)
  },

  [`& .${classes.title}`]: {
    fontWeight: typography.fontWeightBold
  }
}))

export const StyledTypography = styled(Typography)(() => ({
  color: 'rgb(0, 0, 0, 0.6)',
  marginTop: '4px'
}))

export {Root, classes}
